import * as React from 'react';

import {Button} from 'shells/button/button';
import {FooterBar} from 'shells/modal/footer-bar';
import {MarketingHeader} from 'shells/typography/marketing-header';
import {ModalBody} from 'shells/typography/modal-body';

import type {
    DripSequenceFragment as DripSequence,
    SmsDripSequenceFragment as SmsDripSequence,
} from 'nutshell-graphql-types';

import {
    FromActionBox,
    DelayActionBox,
    SmsFromActionBox,
    StartTriggerActionBox,
    CustomClickDomainActionBox,
} from '../../../editions/edition-action-boxes';

import {GetSessionUser} from '../../../../core/get-session-user';

import {getFromAddress} from './helpers';

import styles from './review-sequence.module.css';

type Props = {
    dripSequence: DripSequence | SmsDripSequence;
    isReviewDisabled: boolean;
    editionsMissingDelays: any[];
    canAccessSetup: boolean;
    closeModal: () => void;
    scrollToEdition: (arg1: string) => void;
    onClickPrimary: () => void;
    onClickSecondary: () => void;
};

export function ReviewSequence(props: Props) {
    return (
        <>
            <div className={styles['review-sequence-container']}>
                <MarketingHeader>
                    Prepare to activate{' '}
                    <span className={styles['drip-sequence-name']}>{props.dripSequence.name}</span>
                </MarketingHeader>
                <ModalBody>Review your drip sequence details before activating</ModalBody>
                <div className={styles['drip-requirements-container']}>
                    <GetSessionUser>
                        {({user}) => {
                            return (
                                <>
                                    {props.dripSequence.__typename === 'Campaign' ? (
                                        <FromActionBox
                                            fromAddress={getFromAddress(props.dripSequence)}
                                            closeModal={props.closeModal}
                                        />
                                    ) : (
                                        <SmsFromActionBox
                                            from={props.dripSequence.from}
                                            canAccessSetup={props.canAccessSetup}
                                        />
                                    )}
                                    {/* @ts-expect-error */}
                                    {props.dripSequence.customClickDomain &&
                                    // @ts-expect-error
                                    !props.dripSequence.customClickDomain.isVerified ? (
                                        <CustomClickDomainActionBox
                                            canAccessSetup={Boolean(
                                                user && user.permissions.canAccessSetup
                                            )}
                                        />
                                    ) : undefined}
                                    {props.editionsMissingDelays &&
                                    props.editionsMissingDelays.length ? (
                                        <DelayActionBox
                                            editionsMissingDelays={props.editionsMissingDelays}
                                            closeModal={props.closeModal}
                                            scrollToEdition={() =>
                                                props.scrollToEdition(
                                                    props.editionsMissingDelays[0]
                                                )
                                            }
                                        />
                                    ) : undefined}
                                    {!props.dripSequence.startTrigger &&
                                        props.dripSequence.__typename === 'SmsCampaign' && (
                                            <StartTriggerActionBox
                                                dripSequenceId={props.dripSequence.id}
                                            />
                                        )}
                                </>
                            );
                        }}
                    </GetSessionUser>
                </div>
            </div>
            <FooterBar
                left={
                    <Button variant='text' size='big' onClick={props.onClickSecondary}>
                        Back
                    </Button>
                }
                right={
                    <Button
                        variant='primary'
                        size='big'
                        onClick={props.onClickPrimary}
                        disabled={props.isReviewDisabled}
                    >
                        Review
                    </Button>
                }
            />
        </>
    );
}
